import { render } from "./DashboardOptions.vue?vue&type=template&id=d9632178&scoped=true"
import script from "./DashboardOptions.vue?vue&type=script&lang=js"
export * from "./DashboardOptions.vue?vue&type=script&lang=js"

import "./DashboardOptions.vue?vue&type=style&index=0&id=d9632178&lang=scss&scoped=true"

import exportComponent from "../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9632178"]])

export default __exports__